//结算创建订单及尾款相关
// import utils from '@/utils/utils'
export default {
  namespaced: true,
  state: {
    // tailUseCouponCodes: utils.strJSONParse(sessionStorage.getItem('sg_tailorder_usecouponcodes'), [])//尾款用券券码
  },
  getters: {
    // getTailUseCouponCodes(state) {
    //   return state.tailUseCouponCodes || []
    // },
  },
  mutations: {
    // setTailUseCouponCodes(state, payload) {
    //   state.tailUseCouponCodes = payload
    //   sessionStorage.setItem('sg_tailorder_usecouponcodes', JSON.stringify(payload))
    // }
  },
}
